import Swiper from 'swiper';
import $ from 'jquery';

var slider = document.querySelector('.swiper-container');

function centerSlider () {
  var activeIndex = swiper.activeIndex;
  var windowWidth = $(window).width();

  swiper.setTranslate(-(activeIndex * 630) + ((windowWidth - 600) / 2));
}

if (slider != null) {
  var swiper = new Swiper('.swiper-container', { // eslint-disable-line no-unused-vars
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.swiper-prev',
      nextEl: '.swiper-next',
    },
    loop: true,
    spaceBetween: 30,
    centeredSlides: true,
    init: false,
    simulateTouch: false,
  });

  swiper.on('init', function () {
    if ($(window).width() > 1023) {
      centerSlider();
    }
  });

  swiper.init();

  swiper.on('slideChange', function () {
    if ($(window).width() > 1023) {
      var activeIndex = swiper.activeIndex;
      var windowWidth = $(window).width();

      $('.swiper-wrapper').css('transform', 'translate3d(-' + ((activeIndex * 630) - ((windowWidth - 600) / 2)) + 'px, 0px, 0px');
    }
  });

  $(window).on('resize', function () {
    if ($(window).width() > 1023) {
      centerSlider();
    }
  });
}
